import { render, staticRenderFns } from "./PreviewPay.vue?vue&type=template&id=b26f32e8&scoped=true&"
import script from "./PreviewPay.vue?vue&type=script&lang=js&"
export * from "./PreviewPay.vue?vue&type=script&lang=js&"
import style0 from "./PreviewPay.vue?vue&type=style&index=0&id=b26f32e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b26f32e8",
  null
  
)

export default component.exports